import { ReportRepository } from "@domain/repositories/ReportRepository";
import UseCase from "@domain/UseCase";
import { Report } from "@domain/models/Report";

type Input = Partial<Report>;

type Output = Promise<Report>;

export class CreateReportUseCase implements UseCase<Input, Output> {
  constructor(private readonly reportRepository: ReportRepository) {}

  execute(report: Input) {
    return this.reportRepository.create(report);
  }
}
